"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.participants = void 0;
var paginateAnything_1 = require("../../../functions/util/paginateAnything");
exports.participants = paginateAnything_1.paginateAnything([
    {
        content: {
            id: 33985,
            email: "brian.cassada@dominionenergy.com",
            firstName: "A",
            lastName: "Cassada",
            nickname: null,
            workLocation: {
                id: 33803,
                locationId: "RICH 8TH & MAIN",
                locationType: null,
                name: "Unknown",
                nickname: null,
                locationInformationUrl: null,
                preferUsersLocation: null,
                geolocation: null,
                region: null,
                physicalAddress: null,
                emergencyAddress: null,
                supervisor: null,
                softDeleted: true,
                source: "API_INCOMPLETE",
                dataSourceId: 1350,
                lastModifiedDate: "2020-05-05T23:02:26.295133Z",
            },
            supervisor: {
                id: 34669,
                email: "kelly.k.conway@dominionenergy.com",
                firstName: "Kelly",
                lastName: "Conway",
                nickname: null,
                workLocation: null,
                supervisor: null,
                softDeleted: false,
                dataSourceId: 2002,
                source: "API",
                clientGroups: [],
                teams: [],
                contractingCompany: null,
                primaryGroupId: null,
                participantType: "EMPLOYEE",
                lastModifiedDate: "2020-11-05T04:15:35.712570Z",
                fullName: "Conway, Kelly",
                name: "Kelly Conway",
            },
            softDeleted: false,
            dataSourceId: 2002,
            source: "API",
            clientGroups: [],
            teams: [],
            contractingCompany: null,
            primaryGroupId: null,
            participantType: "EMPLOYEE",
            lastModifiedDate: "2020-12-12T04:11:57.789452Z",
            fullName: "Cassada, A",
            name: "A Cassada",
        },
        dataSourceId: 2002,
        id: 33985,
        softDeleted: false,
        source: "API",
        uniqueId: "brian.cassada@dominionenergy.com",
    },
    {
        content: {
            id: 1075001,
            email: "abhineet.h.parchure@dominionenergy.com",
            firstName: "A",
            lastName: "PARCHURE",
            nickname: null,
            workLocation: {
                id: 33803,
                locationId: "RICH 8TH & MAIN",
                locationType: null,
                name: "Unknown",
                nickname: null,
                locationInformationUrl: null,
                preferUsersLocation: null,
                geolocation: null,
                region: null,
                physicalAddress: null,
                emergencyAddress: null,
                supervisor: null,
                softDeleted: true,
                source: "API_INCOMPLETE",
                dataSourceId: 1350,
                lastModifiedDate: "2020-05-05T23:02:26.295133Z",
            },
            supervisor: {
                id: 33932,
                email: "styler@dvigridsolutions.com",
                firstName: "Stephen",
                lastName: "Tyler",
                nickname: null,
                workLocation: null,
                supervisor: null,
                softDeleted: false,
                dataSourceId: 2002,
                source: "API",
                clientGroups: [],
                teams: [],
                contractingCompany: null,
                primaryGroupId: null,
                participantType: "EMPLOYEE",
                lastModifiedDate: "2020-10-05T05:05:58.070043Z",
                fullName: "Tyler, Stephen",
                name: "Stephen Tyler",
            },
            softDeleted: false,
            dataSourceId: 2002,
            source: "API",
            clientGroups: [],
            teams: [],
            contractingCompany: null,
            primaryGroupId: null,
            participantType: "EMPLOYEE",
            lastModifiedDate: "2021-03-12T04:00:26.026741Z",
            fullName: "PARCHURE, A",
            name: "A PARCHURE",
        },
        dataSourceId: 2002,
        id: 1075001,
        softDeleted: false,
        source: "API",
        uniqueId: "abhineet.h.parchure@dominionenergy.com",
    },
    {
        content: {
            id: 43264,
            email: "al-nasir.a.powell@dominionenergy.com",
            firstName: "A",
            lastName: "Powell",
            nickname: null,
            workLocation: {
                id: 2011,
                locationId: "600 CANAL PLACE",
                locationType: null,
                name: "GRAYLAND OFC",
                nickname: null,
                locationInformationUrl: null,
                preferUsersLocation: null,
                geolocation: {
                    latitude: 37.54891388888889,
                    longitude: -77.472675,
                    valid: true,
                    gpsString: "(37.548914, -77.472675)",
                },
                region: null,
                physicalAddress: null,
                emergencyAddress: null,
                supervisor: null,
                softDeleted: true,
                source: "USER_GENERATED",
                dataSourceId: null,
                lastModifiedDate: "2020-05-05T23:02:57.738924Z",
            },
            supervisor: {
                id: 42748,
                email: "matthew.s.may@dominionenergy.com",
                firstName: "Matthew",
                lastName: "May",
                nickname: null,
                workLocation: null,
                supervisor: null,
                softDeleted: false,
                dataSourceId: 2002,
                source: "API",
                clientGroups: [],
                teams: [],
                contractingCompany: null,
                primaryGroupId: null,
                participantType: "EMPLOYEE",
                lastModifiedDate: "2021-05-03T04:00:39.170884Z",
                fullName: "May, Matthew",
                name: "Matthew May",
            },
            softDeleted: false,
            dataSourceId: 2002,
            source: "API",
            clientGroups: [],
            teams: [],
            contractingCompany: null,
            primaryGroupId: null,
            participantType: "EMPLOYEE",
            lastModifiedDate: "2021-04-30T04:00:42.124072Z",
            fullName: "Powell, A",
            name: "A Powell",
        },
        dataSourceId: 2002,
        id: 43264,
        softDeleted: false,
        source: "API",
        uniqueId: "al-nasir.a.powell@dominionenergy.com",
    },
]);
//# sourceMappingURL=participants.js.map